/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Codec_AacInputs */



/**
* | output |
* | --- |
* | "AAC" |
*
* @param {Audio_Embed_Export_Codec_AacInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_codec_aac = /** @type {((inputs?: Audio_Embed_Export_Codec_AacInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Codec_AacInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("AAC")
	if (locale === "de") return /** @type {LocalizedString} */ ("AAC")
	if (locale === "it") return /** @type {LocalizedString} */ ("AAC")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ААК")
	if (locale === "es") return /** @type {LocalizedString} */ ("CAA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("辅助空调系统")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AAC")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एएसी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("AAC")
	return /** @type {LocalizedString} */ ("AAC")
});